export default __webpack_public_path__ + "static/media/sunflower-trust.7773d1cd.png";